export const SAVE_USERNAME_PATH = '@supermarket-list:username'
